module.exports = __webpack_public_path__ + "img/decoration-logo.6cf64134.svg";